<template>
  <div>
    <BaseList
      :columns="columns"
      :data="TotalInfo && TotalInfo.rows ? TotalInfo.rows : []"
      :pagination="
        TotalInfo
          ? {
              total: TotalInfo.count,
              current: TotalInfo.page,
              pageSize: TotalInfo.limit,
            }
          : {}
      "
      :titleAdd="$t('i18nCommon.AddSupplier')"
      @change="handleTableChange"
      @editRow="editRow"
      @deleteRow="deleteRow"
      @onDblclick="onDblclick"
      @addData="addData"
      @loadDataFilter="loadDataFilter"
    >
    </BaseList>
    <div v-if="isShow && supplier && Object.keys(supplier).length > 0">
      <a-modal v-model:open="isShow" centered :width="800" :closable="false">
        <div class="header-detail flex justify-between mb-6">
          <div class="font-bold text-2xl">
            {{ $t("i18nCommon.TitleDetailInfo") }}
          </div>
          <div
            class="text-white h-9 w-36 bg-slate-900 rounded-lg flex justify-center items-center"
          >
            {{ $t("i18nCommon.Supplier") }}
          </div>
        </div>
        <div class="content">
          <div class="product-detail-form">
            <a-form
              ref="ruleFormRef"
              :model="ruleForm"
              :rules="rules"
              label-width="120px"
              class="demo-ruleForm"
              :size="formSize"
              status-icon
            >
              <div class="flex columns-2">
                <a-form-item prop="name" testek="name" class="w-full mr-8">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Name") }}
                    </div>
                    <a-input v-model:value="supplier.supName" :disabled="true" />
                  </div>
                </a-form-item>
                <!-- <a-form-item prop="status" testek="status" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Status") }}
                    </div>
                    <a-input v-model:value="supplier.status" :disabled="true" />
                  </div>
                </a-form-item> -->
              </div>
              <div class="flex columns-2">
                <a-form-item prop="phone" testek="phone" class="w-full mr-8">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Phone") }}
                    </div>
                    <a-input v-model:value="supplier.supPhone" :disabled="true" />
                  </div>
                </a-form-item>
                <a-form-item prop="contact" testek="contact" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Contact") }}
                    </div>
                    <a-input v-model:value="supplier.supContactName" :disabled="true" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-2">
                <a-form-item prop="conutry" testek="conutry" class="w-full mr-8">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Conutry") }}
                    </div>
                    <a-input v-model:value="supplier.supCountry" :disabled="true" />
                  </div>
                </a-form-item>
                <a-form-item prop="city" testek="city" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.City") }}
                    </div>
                    <a-input v-model:value="supplier.supCity" :disabled="true" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-1">
                <a-form-item prop="address" testek="address" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Address") }}
                    </div>
                    <a-textarea v-model:value="supplier.supAddress" :disabled="true" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-1">
                <a-form-item prop="postalCode" testek="postalCode" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.PostalCode") }}
                    </div>
                    <a-input v-model:value="supplier.supPostalCode" :disabled="true" />
                  </div>
                </a-form-item>
              </div>
            </a-form>
          </div>
        </div>
        <template #footer>
          <a-button key="back" @click="isShow = false">{{
            $t("i18nCommon.Close")
          }}</a-button>
        </template>
      </a-modal>
    </div>
  </div>
</template>
<script>
import BaseList from "@/views/base/BaseList.vue";
import { mapGetters, mapActions } from "vuex";
import { ModuleSupplier } from "@/store/module-const";
import { Modal } from "ant-design-vue";
export default {
  name: "SupplierList",
  components: {
    BaseList,
  },
  data() {
    return {
      columns: [],
      pagination: {
        total: 200,
        current: 1,
        pageSize: 20,
      },
      supplier: {},
      isShow: false,
    };
  },
  computed: {
    ...mapGetters(ModuleSupplier, ["TotalInfo"]),
  },
  async created() {
    const me = this;
    me.initDataStatic();

    await me.loadDataGrid();
  },
  methods: {
    ...mapActions(ModuleSupplier, [
      "getSuppliers",
      "updateSupplier",
      "deleteSupplier",
      "getSupplier",
    ]),
    handleTableChange: _.debounce(async function (page) {
      const me = this;
      me.pagination.current = page.current;
      me.pagination.pageSize = page.pageSize;
      me.pagination.total = page.total;
      await me.loadDataGrid();
    }, 300),
    loadDataFilter: _.debounce(async function (params) {
      const me = this;
      let payload = {
        ...me.payload,
        ...params,
        limit: me.pagination.pageSize,
        page: 1,
      };
      await me.getSuppliers(payload);
    }, 300),
    initDataStatic() {
      const me = this;
      me.columns = [
        {
          fixed: "left",
          title: me.$t("i18nCommon.SupplierInfo.Name"),
          dataIndex: "supName",
          sorter: (a, b) => me.$commonFunc.sortColumn(a.supName, b.supName),
          width: 200,
          columnKey: "name",
        },
        {
          title: me.$t("i18nCommon.SupplierInfo.Address"),
          dataIndex: "supAddress",
          sorter: (a, b) => me.$commonFunc.sortColumn(a.supAddress, b.supAddress),
          width: 300,
          columnKey: "name",
        },
        {
          title: me.$t("i18nCommon.SupplierInfo.PhoneNumber"),
          dataIndex: "supPhone",
          sorter: (a, b) => me.$commonFunc.sortColumn(a.supPhone, b.supPhone),
          width: 250,
          columnKey: "name",
        },
        {
          title: me.$t("i18nCommon.SupplierInfo.ContactName"),
          dataIndex: "supContactName",
          sorter: (a, b) => me.$commonFunc.sortColumn(a.supContactName, b.supContactName),
          width: 250,
          columnKey: "name",
        },
        {
          title: me.$t("i18nCommon.SupplierInfo.City"),
          dataIndex: "supCity",
          sorter: (a, b) => me.$commonFunc.sortColumn(a.supCity, b.supCity),
          width: 250,
          key: "name",
        },
        {
          title: me.$t("i18nCommon.SupplierInfo.Country"),
          dataIndex: "supCountry",
          sorter: (a, b) => me.$commonFunc.sortColumn(a.supCountry, b.supCountry),
          width: 250,
          columnKey: "name",
        },
        {
          title: me.$t("i18nCommon.SupplierInfo.PostalCode"),
          dataIndex: "supPostalCode",
          sorter: (a, b) => me.$commonFunc.sortColumn(a.supPostalCode, b.supPostalCode),
          width: 250,
        },
        {
          title: me.$t("i18nCommon.Action"),
          key: "rightWidgetDefault",
          fixed: "right",
          width: 150,
        },
      ];
    },
    async loadDataGrid() {
      const me = this;
      let payload = {
        ...me.payload,
        limit: me.pagination.pageSize,
        page: me.pagination.current,
      };
      await me.getSuppliers(payload);
    },

    editRow: _.debounce(async function (dataRow) {
      const me = this;
      if (!dataRow) return;
      me.$router.push("/create-supplier");
      setTimeout(() => {
        me.$emitter.emit("LoadEditSupplier", {
          id: dataRow.id,
          mode: me.$enum.Mode.Edit,
        });
      }, 300);
    }, 300),

    deleteRow: _.debounce(async function (dataRow) {
      const me = this;
      if (!dataRow) {
        me.$messageNotification.messageNotification(
          me.$t("i18nCommon.DeleteSupplierFail"),
          "warning"
        );
        return;
      }

      Modal.confirm({
        title: me.$t("i18nCommon.Confirm"),
        content: me.$t("i18nCommon.DeleteSupplierConfirm", {
          name: dataRow.supName,
        }),
        okText: me.$t("i18nCommon.Yes"),
        cancelText: me.$t("i18nCommon.No"),
        centered: true,
        async onOk() {
          let result = await me.deleteSupplier({ id: dataRow.id });
          if (result && result.code == 200) {
            await me.loadDataGrid();
            //Thông báo
            me.$messageNotification.messageNotification(
              me.$t("i18nCommon.DeleteSupplierSuccess")
            );
          } else if (result && (result.statusCode == 400 || result.statusCode == 409)) {
            me.$messageNotification.messageNotification(result.message, "warning");
          } else {
            me.$messageNotification.messageNotification(
              me.$t("i18nCommon.DeleteSupplierFail"),
              "warning"
            );
          }
        },
      });
    }, 300),

    async onDblclick(params) {
      const me = this;
      if (!params || !params.id) return;

      //lấy dữ liệu chi tiết từ API
      me.supplier = await me.getSupplier({ id: params.id });
      if (me.supplier) {
        me.isShow = true;
      } else {
      }
    },
    addData() {
      const me = this;
      me.$router.push("/create-supplier");
    },
  },
};
</script>

<style lang="scss" scoped>
.ant-input[disabled] {
  background: initial !important;
  color: initial !important;
}
</style>
